// extracted by mini-css-extract-plugin
export default {"container":"PriceList_container__vzb61","wrapper":"PriceList_wrapper__7B9Fk","footerStyle":"PriceList_footerStyle__qY3Pg"};